import { useMutation } from '@provision/graphql-client';
import { useCallback } from 'react';
import { RESOLVE_SIGNAL_INCIDENT_MUTATION } from 'src/graphql/entities/signal-incident/signal-incident.operations';
import type { SignalIncidentRaw } from 'src/types';
import { useNotifications } from 'src/utils/hooks';

interface ResolveSignalIncidentMutation {
  resolveSignalIncident: {
    signalIncident: SignalIncidentRaw;
  };
}

interface UpdateSignalIncidentInput {
  signalIncidentId: string;
}

export function useUpdateSignalIncident(): {
  loading: boolean;
  updateSignalIncident: (input: UpdateSignalIncidentInput) => Promise<unknown>;
} {
  const { showErrorAlert } = useNotifications();

  const [resolveSignalIncidentMutation, { loading }] = useMutation<ResolveSignalIncidentMutation>(
    RESOLVE_SIGNAL_INCIDENT_MUTATION,
    {
      onError: (error) => {
        console.error(error);
        showErrorAlert('Something went wrong resolving signal incident, please try again');
      },
    },
  );

  const updateSignalIncident = useCallback(
    ({ signalIncidentId }: UpdateSignalIncidentInput) => {
      return resolveSignalIncidentMutation({
        variables: {
          input: {
            signalIncidentId,
          },
        },
      });
    },
    [resolveSignalIncidentMutation],
  );

  return {
    loading,
    updateSignalIncident,
  };
}
